import { Alert, Icon, Button } from "antd";
import styled from "styled-components";
import { SecondaryButtonComponent } from "../../../../../../../CommonComponents/commonStyles";

export const NoticeContent = styled.div`
justify-content: space-between !important;
color: ${props => props.theme.fontColors.thead};
  flex-direction: column;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  justify-content: space-between !important;
  & > div:nth-child(1) {
    flex-basis: 75%;
    margin-bottom: ${props => props.theme.spacing.margins.webBase};
    line-height: ${props => props.theme.lineHeight.subHeading};
  }
  && div > a {
    color: ${props => props.theme.colors.primaryColor};
  }
  & > button {
    width: initial;
    align-self: flex-start;
  }
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
  
`;

export const SecondaryButtonWrapper = styled(Button)`
  font-size: 0.875rem;
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  border-radius: 18px;
  box-shadow: 0;
  outline: 0;
  color: #006778;
  border: 1px solid #d4d4d4;
  > span {
    font-weight: 500;
    padding-left: 3px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
  &:hover, :focus {
    outline: 0;
    color: #006778;
    border: 1px solid #d4d4d4;
    box-shadow: none;
  }
  @media only screen and (max-width: 991.92px) {
    width: 135px;
  }
`;

export const NoticeBorder = styled.div`
border-left: 6px solid ${props => props.theme.colors.info};
width: 100%;
margin-bottom: 50px;

@media only screen and (min-width: 320px) and (max-width: 767px) {
  border-left: none;
  border-top: 4px solid ${props => props.theme.colors.info};
}
`;

export const NoticeContainer = styled(Alert)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  background-color: ${props => props.theme.backgroundColor.cardDark};
  border-radius: 0px;
  border: none;
  padding: 20px 30px !important;
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    font-size: 14px;
    padding: 20px !important;
  }
`;

export const SubmitBold = styled.span`
  font-family: ${props =>
    props.theme.fontFamily.helveticaNeueBold};
`;

export const DownIcon = styled(Icon)`
  font-size: 10px; 
  padding-top: 0.24rem;
`;

export const ShowMoreWrap = styled.div`
  width:135px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    align-self: flex-start;
  }
`;
